import request from '@/utils/request'
import Cookies from 'js-cookie'

import config from '../config/config'

const TRS_URL = config.TRS_URL
const BIZ_URL = config.BIZ_URL

export function login(username, password) {
  return request({
    url: '/user/login',
    method: 'post',
    data: {
      username,
      password,
    },
  })
}

export function getInfo(token) {
  return request({
    url: '/user/info',
    method: 'get',
    params: { token },
  })
}

export function logout() {
  Cookies.remove('cy_user', { path: '/', domain: '.caiyunapp.com' })
  return request({
    url: '/user/logout',
    method: 'post',
  })
}

export function sendCode(phone_num) {
  return request({
    url: `${BIZ_URL}/v1/send_sms_code`,
    method: 'post',
    data: {phone_num}
  })
}
export function codeloginsend(phone_num,codeId,code) {
  return request({
    url: `${BIZ_URL}/v1/web_login_by_code`,
    method: 'post',
    data: {
      "phone_num": phone_num,
      "codeId": codeId,
      "code": code
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js